export default "__VITE_ASSET__iRCFbUeQ__"